// extracted by mini-css-extract-plugin
module.exports = {"heading":"account-type-list-columns_heading__1sP1u"};